<template>
  <div class="auswertungen">
    <v-row>
      <v-col>
        <h2>Auswertungen</h2>
      </v-col>
    </v-row>
    <div class="filter">
      <v-row>
        <v-col>
          <h3>Filter</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-combobox
              class="pt-1"
              label="Akronym"
              :items="filterValuesAcronym"
              v-model="filter.acronym"
              @change="ladeGefilterteAuswertungen(filter.acronym, 'acronym')"
              clearable
              outlined
              dense
              hideDetails="auto"
          />
        </v-col>
        <v-col cols="3">
          <b-date-field
              label="Zeitraum von"
              v-model="filter.beginn"
              @change="ladeGefilterteAuswertungen(filter.beginn, 'beginn')"
              regular
          />
        </v-col>
        <v-col cols="3">
          <b-date-field
              label="Zeitraum bis"
              v-model="filter.ende"
              @change="ladeGefilterteAuswertungen(filter.ende, 'ende')"
              regular
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-combobox
              label="Bekanntmachung"
              :items="filterValuesBekanntmachungen"
              v-model="filter.bekanntmachung"
              @change="ladeGefilterteAuswertungen(filter.bekanntmachung, 'bekanntmachung')"
              clearable
              outlined
              dense
          />
        </v-col>
        <v-col>
          <v-combobox
              label="Rechtsform"
              :items="filterValuesRechtsformen"
              v-model="filter.rechtsform"
              @change="ladeGefilterteAuswertungen(filter.rechtsform, 'rechtsform')"
              clearable
              outlined
              dense
          />
        </v-col>
        <v-col>
          <v-combobox
              label="ZE_Bundesland"
              :items="filterValuesBundeslaender"
              v-model="filter.bundesland"
              @change="ladeGefilterteAuswertungen(filter.bundesland, 'bundesland')"
              clearable
              outlined
              dense
          />
        </v-col>
        <v-col>
          <v-combobox
              label="ZE_Empfängergruppe"
              :items="filterValuesEmpfaengergruppen"
              v-model="filter.empfaenger"
              @change="ladeGefilterteAuswertungen(filter.empfaenger, 'empfaenger')"
              clearable
              outlined
              dense
          />
        </v-col>
      </v-row>
    </div>
    <div class="auswertungsTabellen" v-if="abschnittuebersichtList.length > 0">
        <v-row v-for="(abschnitt, abschnitt_index) in abschnittuebersichtList" :key="abschnitt_index">
          <v-col>
            <b-data-table
                :headers="erstelleHeader(abschnitt_index, abschnitt)"
                :items="abschnitt.frageübersichtList"
            >
              <template #[`item.aktionen`]="{ item }">
                <v-icon
                  small
                  @click="downloadFrage(item, abschnitt)"
                >mdi-download</v-icon>
              </template>
            </b-data-table>
            <a v-if="abschnitt.frageübersichtList.length > 0" href="#" @click="downloadAbschnitt(abschnitt)">
              <v-icon small color="#6B92E6">mdi-download</v-icon>
              Alle runterladen
            </a>
          </v-col>
        </v-row>
    </div>
    <div class="keineAuswertungen" v-else>
      <p><b>noch keine Auswertungen vorhanden</b></p>
    </div>
  </div>
</template>

<script>

import dataMixin from "@/mixins/data-mixin";
import axios from 'axios';
import fileDownload from 'js-file-download';
import {mapGetters} from "vuex";

export default {
  name: 'Auswertungen',
  data() {
    return {
      filterValuesAcronym: [],
      filterValuesBekanntmachungen: [],
      filterValuesRechtsformen: [],
      filterValuesBundeslaender: [],
      filterValuesEmpfaengergruppen: [],
      filter: {
        acronym: null,
        beginn: null,
        ende: null,
        bekanntmachung: null,
        rechtsform: null,
        bundesland: null,
        empfaenger: null
      }
    };
  },
  mixins: [
    dataMixin('abschnittuebersichtList', 'loadedData.auswertungen.abschnittuebersichtList'),
    dataMixin('fragebogenIdList', 'loadedData.auswertungen.fragebogenIdList'),
  ],
  computed: {
    ...mapGetters('userData', ['getUserData']),
  },
  methods: {
    ladeAuswertungen() {
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}`)
        .then((response) => {
          this.abschnittuebersichtList = response.data.abschnittübersichtList;
          this.fragebogenIdList = response.data.fragebogenIdList;
        });
    },
    ladeGefilterteAuswertungen(filterValue, filterKey) {
      if (filterValue === '') {
        this.filter[filterKey] = null;
      }
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}`, { params: this.filter })
        .then((response) => {
          this.abschnittuebersichtList = response.data.abschnittübersichtList;
          this.fragebogenIdList = response.data.fragebogenIdList;
          this.ladeMoeglicheFilterwerte();
        });
    },
    erstelleHeader(abschnittIndex, abschnitt) {
      const header = [
        {
          text: (abschnittIndex+1) + '.',
          value: abschnittIndex,
          sortable: false,
        },
        {
          text: abschnitt.abschnittsname,
          value: 'frage',
        },
        {
          text: 'Summe der Antworten',
          value: 'wert',
        },
        {
          text: 'Download',
          value: 'aktionen',
          sortable: false,
        }
      ];
      return header;
    },
    downloadFrage(item, abschnitt) {
      const downloadItems = {
        abschnitte: [{
          abschnittname: abschnitt.abschnittsname,
          fragen: [item]
        }],
        fragebogenIds: this.fragebogenIdList,
        filterSet: this.filter
      };
      const downloadFrage = axios.post('/v1/fragebogen/download', downloadItems, { responseType: 'blob' } );
      downloadFrage.then((data) => {
        fileDownload(data.data, 'auswertung.xlsx');
      });
    },
    downloadAbschnitt(abschnitt) {
      const downloadItems = {
        abschnitte: [{
          abschnittname: abschnitt.abschnittsname,
          fragen: abschnitt.frageübersichtList
        }],
        fragebogenIds: this.fragebogenIdList,
        filterSet: this.filter
      };
      const downloadAbschnitt = axios.post('/v1/fragebogen/download', downloadItems, { responseType: 'blob' } );
      downloadAbschnitt.then((data) => {
        fileDownload(data.data, 'auswertung.xlsx');
      });
    },
    erstelleAuswertungenDummy() {
      this.abschnittuebersichtList = [
        {
          abschnittsname: 'Wissenschaftliche Verwertungen',
          abschnittsWert: 94,
          frageübersichtList: [
            {
              frage: 'Anzahl an Publikationen',
              wert: 22
            },
            {
              frage: 'Anzahl an Präsentationen',
              wert: 25
            },
          ]
        },
        {
          abschnittsname: 'Wirtschaftliche Verwertungen',
          abschnittsWert: 107,
          frageübersichtList: [
            {
              frage: 'Anzahl an Projektergebnissen zu Produkten',
              wert: 23
            },
            {
              frage: 'Anzahl an Projektergebnissen zu Dienstleistungen',
              wert: 13
            },
          ]
        }
      ];
    },
    getFilterValuesAkronym() {
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}/acronym`, { params: this.filter })
        .then((response) => {
          this.filterValuesAcronym = response.data;
        });
    },
    getFilterValuesBekanntmachungen() {
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}/titelBK`, { params: this.filter })
        .then((response) => {
          this.filterValuesBekanntmachungen = response.data;
        });
    },
    getFilterValuesRechtsformen() {
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}/rechtsform`, { params: this.filter })
        .then((response) => {
          this.filterValuesRechtsformen = response.data;
        });
    },
    getFilterValuesBundeslaender() {
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}/bundesland`, { params: this.filter })
        .then((response) => {
          this.filterValuesBundeslaender = response.data;
        });
    },
    getFilterValuesEmpfaengergruppen() {
      axios.get(`/v1/fragebogen/auswertungsuebersicht/${this.getUserData.projekttraegerschaftName}/empfängergruppe`, { params: this.filter })
        .then((response) => {
          this.filterValuesEmpfaengergruppen = response.data;
        });
    },
    ladeMoeglicheFilterwerte() {
      this.getFilterValuesAkronym();
      this.getFilterValuesBekanntmachungen();
      this.getFilterValuesRechtsformen();
      this.getFilterValuesBundeslaender();
      this.getFilterValuesEmpfaengergruppen();
    }
  },
  created() {
    this.ladeAuswertungen();
    // this.erstelleAuswertungenDummy();
  },
  mounted() {
    this.ladeMoeglicheFilterwerte();
  }
};
</script>
<style lang="scss" scoped>

.auswertungen {
  .v-data-table {
    margin-top: 20px;
  }
  a {
    text-decoration: none;
    float: right;
    color: #6B92E6;
  }
}

.keineAuswertungen {
  text-align: center;
  padding: 120px 0 80px;
  p {
    font-size: 18px;
  }
}

</style>